import VerticalLayout from "../../../../../lib/html5-software-library/src/ranj/components/layouts/VerticalLayout";
import ScrollPane from "../../../../../lib/html5-software-library/src/ranj/components/scrolling/ScrollPane";
import Rectangle from "../../../../../lib/html5-software-library/src/ranj/geom/Rectangle";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ChatContactItemFactory from "../controller/ChatContactItemFactory";
import ChatInteractionEvent from "../events/ChatInteractionEvent";
import ChatNpcMessageEvent from "../events/ChatNpcMessageEvent";
import ChatModel from "../model/ChatModel";
import ChatContactItemMediator from "./ChatContactItemMediator";

export default class ChatContactsScreenMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {RevisableLanguagePack} languagePack 
     * @param {ChatModel} chatModel 
     * @param {ChatContactItemFactory} chatContactItemFactory 
     */
    constructor(target, dispatcher, layoutManager, languagePack, chatModel, chatContactItemFactory) {
        super(target, dispatcher, layoutManager);

        this._languagePack = languagePack;
        this._chatModel = chatModel;
        this._chatContactItemFactory = chatContactItemFactory;

        this._skinKeyRegistry = this.getCustomData().skinKeyRegistry;

        /** @type {Array<ChatContactItemMediator>} */
        this._contactItems = [];
    }

    initialize() {
        super.initialize();

        this._contactsContainer = new VerticalLayout(this._target.scrollPane.contentContainer, 5);

        const scrollPaneBounds = this._target.scrollPane.nominalBounds;
        const viewport = new Rectangle(0, 0, scrollPaneBounds.width, scrollPaneBounds.height);
        const halvedScrollHandleHeight = this._target.scrollBar.dragButton.nominalBounds.height * .5;
        this._scrollPane = new ScrollPane(viewport, null, this._target.scrollBar, this._target.scrollPane.contentContainer, null, true, true, halvedScrollHandleHeight);

        this._updateContactItems();
        this._scrollPane.update();
        this._scrollPane.setScrollPosition(0, 0);

        this.registerEventListener(ChatInteractionEvent.CHAT_STARTED, this._updateContactItems.bind(this));
        this.registerEventListener(ChatNpcMessageEvent.SENT, this._updateContactItems.bind(this));
    }

    destroy() {
        super.destroy();

        this._destroyContactItem();

        this._scrollPane.setScrollPosition(0, 0);
        this._scrollPane.destroy();
    }

    _destroyContactItem() {
        for (let i = 0; i < this._contactItems.length; i++) {
            const contactItem = this._contactItems[i];
            this._contactsContainer.removeItem(contactItem.skin);
            contactItem.destroy();
        }

        this._contactItems = [];
    }

    _updateContactItems() {
        this._destroyContactItem();

        const npcIds = this._chatModel.contactIds;
        for (let i = 0; i < npcIds.length; i++) {
            const npcId = npcIds[i];
            const chatContactItemMediator = this._chatContactItemFactory.createItem(npcId, this._skinKeyRegistry);
            if (chatContactItemMediator.hasNewItems) {
                this._contactsContainer.addItem(chatContactItemMediator.skin, 0);
                this._contactItems.push(chatContactItemMediator);
            } else {
                this._contactsContainer.addItem(chatContactItemMediator.skin);
                this._contactItems.unshift(chatContactItemMediator);
            }
        }

        this._updateScrollPane();
    }

    _updateScrollPane() {
        const contentBounds = this._contactsContainer.getBounds();
        let contentHeight = contentBounds ? contentBounds.height : 0;
        this._scrollPane.setHeightBound(contentHeight);
    }
}